import React, { useState, useEffect } from "react";
import "./styles.css";

/**
 * @function UINotifiToggle
 * @param {STRING} className - Allows us to pass a specific className to the toggle.
 * @param {STRING} toggled - Allows us to toggle the toggle.
 * @return {React.Component}
 * @exported trues
 * @description This is a toggle that allows the use to toggle an option on or off.
 * @example
 * <UIToggle className="some-class" toggled="checked" />
 */

export default function UINotifiToggle(props) {
  const className = props.className ?? "";
  //const toggled = props.checked;
  const dataPoint = props.dataPoint ?{"data-point":props.dataPoint}:{};
  const [ getToggle, setToggle ] = useState(props.value ?? false);

  const onChange = () => {
    if(props.disabledPrompt !== true) {
      if(props.onChange instanceof Function) {
        props.onChange(!getToggle);
      }

      setToggle(!getToggle);
    }
  }

  useEffect(() => setToggle(props.value ?? false), [ props.value ]);

  return(
    <div className={className + " ui-notifi-toggle"} {...dataPoint} onClick ={props.onClick}>
      <label className="toggle-switch">
        <input className="toggle-checkbox" type="checkbox" checked={getToggle} onChange={onChange} />
        <div className="toggle-background"></div>
        <div className="toggle-switch-indicator"></div>
      </label>
    </div>
  );
}